import { render, staticRenderFns } from "./monitoringTable.vue?vue&type=template&id=97f1c518&scoped=true&"
import script from "./monitoringTable.vue?vue&type=script&lang=js&"
export * from "./monitoringTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f1c518",
  null
  
)

export default component.exports